import styled from '@emotion/styled'

import { colors, palette, spacing, typography } from 'main/ui'

export const Tab = styled.div<{ active?: boolean }>`
  border-bottom: ${({ active }) => `2px solid ${active ? palette.almostBlack : 'transparent'}`};
  border-top: 2px solid transparent;
  color: ${({ active }) => (active ? palette.almostBlack : palette.slate)};
  cursor: pointer;
  display: flex;
  font-family: ${typography.fontFamily.ui};
  font-size: ${typography.fontSize.text};
  font-weight: ${typography.fontWeight.bold};
  line-height: 24px;
  padding: ${spacing.minorScale(3)}px ${spacing.minorScale(5)}px;
  text-align: center;
  justify-content: center;
  text-transform: uppercase;
`

export const Container = styled.div<{ full?: boolean; outline?: boolean }>`
  border-bottom: ${({ outline }) => `1px solid ${outline ? colors.border.default : 'transparent'}`};
  border-top: ${({ outline }) => `1px solid ${outline ? colors.border.default : 'transparent'}`};
  display: flex;
  flex: ${({ full }) => (full ? '1' : '0 1 auto')};
  overflow-x: auto;

  ${Tab} {
    flex: ${({ full }) => (full ? '1' : '0 1 auto')};
  }
`
